import { FormikErrors } from 'formik'

import { MAX_SUM_INSURED } from '../../_utils/environmentConst.provider'
import {
  biggerThanZero,
  lowerOrEqualThan,
  onlyNumber,
  required,
} from '../../_utils/formValidators'
import { InsuredAndDeductibleValues } from './Deductible.view'

const validateInsuredType = (insuredType: string) => {
  return required.default(insuredType)
}

export const validateDeductible = (
  formValueFields: InsuredAndDeductibleValues,
) => {
  const deductibleNumeric = Number(formValueFields.deductible)
  let insuredSumatory = 0
  ;[...Array(5)].map((_, index) => {
    insuredSumatory += formValueFields[`insuredVehicle${index + 1}`]
  })

  return (
    required.default(deductibleNumeric) ||
    onlyNumber.default(deductibleNumeric) ||
    biggerThanZero.default(deductibleNumeric) ||
    lowerOrEqualThan('validator.deductibleSumExceeded')(
      deductibleNumeric,
      insuredSumatory,
    ) ||
    lowerOrEqualThan('validator.deductibleMaxExceeded')(
      deductibleNumeric,
      MAX_SUM_INSURED,
    )
  )
}

const validateSameInsuredSum = (insuredSum: number) => {
  return (
    required.default(insuredSum.toString()) ||
    onlyNumber.default(insuredSum) ||
    biggerThanZero.default(insuredSum) ||
    lowerOrEqualThan('validator.globalInsuredSumExceeded')(
      insuredSum,
      MAX_SUM_INSURED,
    )
  )
}

const validateDifferentInsuredSum = (
  formValueFields: InsuredAndDeductibleValues,
  vehiclesToEnsure: number,
  errors: FormikErrors<InsuredAndDeductibleValues>,
) => {
  ;[...Array(vehiclesToEnsure)].map((_, index) => {
    if (
      validateIndividualVehicleSum(
        formValueFields[`insuredVehicle${index + 1}`],
      )
    ) {
      errors[`insuredVehicle${index + 1}`] = validateIndividualVehicleSum(
        formValueFields[`insuredVehicle${index + 1}`],
      )
    }
  })

  return errors
}

export const validateIndividualVehicleSum = (insuredVehicleSum: number) => {
  return (
    onlyNumber.default(insuredVehicleSum) ||
    biggerThanZero.default(insuredVehicleSum) ||
    lowerOrEqualThan('validator.globalInsuredSumExceeded')(
      insuredVehicleSum,
      MAX_SUM_INSURED,
    )
  )
}

export const validateSingleInsuredVehicle = (insuredValue: number) => {
  return (
    required.default(insuredValue.toString()) ||
    onlyNumber.default(insuredValue) ||
    biggerThanZero.default(insuredValue) ||
    lowerOrEqualThan('validator.globalInsuredSumExceeded')(
      insuredValue,
      MAX_SUM_INSURED,
    )
  )
}

export const validateFieldForm = (
  formValueFields: InsuredAndDeductibleValues,
  vehiclesToEnsure: number,
) => {
  let errors: FormikErrors<InsuredAndDeductibleValues> = {}

  if (validateInsuredType(formValueFields.sumInsuredType)) {
    errors.sumInsuredType = validateInsuredType(formValueFields.sumInsuredType)
  }

  if (
    formValueFields.sumInsuredType &&
    formValueFields.sumInsuredType === 'same'
  ) {
    if (validateSameInsuredSum(formValueFields.sumInsured)) {
      errors.sumInsured = validateSameInsuredSum(formValueFields.sumInsured)
    }
  }

  if (
    formValueFields.sumInsuredType &&
    formValueFields.sumInsuredType === 'different'
  ) {
    if (
      validateDifferentInsuredSum(formValueFields, vehiclesToEnsure, errors)
    ) {
      errors = validateDifferentInsuredSum(
        formValueFields,
        vehiclesToEnsure,
        errors,
      )
    }
  }

  if (validateDeductible(formValueFields)) {
    errors.deductible = validateDeductible(formValueFields)
  }

  return errors
}
